import React, { useMemo } from "react";
import { Slider } from "@/components/ui/slider";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ShieldCheck, CircleSlash } from "lucide-react";
import { QUICK_ACTIONS } from "@/mock";

export const intensityColor = (v) => {
  if (v >= 8) return "#E8735A";
  if (v >= 5) return "#E9A84C";
  return "#6E9A7C";
};

export const STRATEGIES = [...QUICK_ACTIONS.map((q) => q.label), "Respiration 4-7-8", "La règle des 10 minutes", "Autre"];

const LABEL = "mb-2 block text-sm font-semibold";
const OUTCOMES = [
  { value: "resisted", label: "J'ai résisté", Icon: ShieldCheck, active: "border-[#2F4A3A] bg-[#2F4A3A] text-white", hover: "hover:border-[#2F4A3A]", testid: "outcome-resisted" },
  { value: "gave_in", label: "J'ai craqué", Icon: CircleSlash, active: "border-[#E8735A] bg-[#E8735A] text-white", hover: "hover:border-[#E8735A]", testid: "outcome-gave-in" },
];

export function IntensityField({ value, onChange }) {
  const sliderValue = useMemo(() => [value], [value]);
  return (
    <div>
      <div className="mb-3 flex items-center justify-between">
        <span className="text-sm font-semibold">Intensité</span>
        <span className="font-display text-2xl font-semibold" style={{ color: intensityColor(value) }} data-testid="intensity-value">{value}/10</span>
      </div>
      <Slider value={sliderValue} min={1} max={10} step={1} onValueChange={(v) => onChange(v[0])} data-testid="intensity-slider" />
    </div>
  );
}

export function SelectField({ label, value, onChange, options, testid, placeholder }) {
  return (
    <div>
      <span className={LABEL}>{label}</span>
      <Select value={value || undefined} onValueChange={onChange}>
        <SelectTrigger className="rounded-xl bg-white" data-testid={testid}><SelectValue placeholder={placeholder} /></SelectTrigger>
        <SelectContent>{options.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}</SelectContent>
      </Select>
    </div>
  );
}

export function OutcomeField({ value, onChange }) {
  return (
    <div>
      <span className={LABEL}>Résultat</span>
      <div className="grid grid-cols-2 gap-3">
        {OUTCOMES.map(({ value: v, label, Icon, active, hover, testid }) => (
          <button key={v} type="button" onClick={() => onChange(v)} data-testid={testid}
            className={`flex items-center justify-center gap-2 rounded-2xl border-2 px-3 py-3 text-sm font-semibold transition-colors ${value === v ? active : `border-[#E9E1D6] bg-white text-[#4A5A50] ${hover}`}`}>
            <Icon size={18} /> {label}
          </button>
        ))}
      </div>
    </div>
  );
}
